import { Stack, Typography, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";
import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";

type Props = {
	title: string;
	icon?: ReactNode;
	muted?: boolean;
	compactTop?: boolean;
};

export const SectionHeader: FC<Props> = ({
	title,
	icon,
	muted = false,
	compactTop,
}) => {
	const { spacingTokens } = useTheme();
	const hasGoalsRight = useGoalsRightOptional();
	const labelColor = hasGoalsRight ? "grey.500" : "text.secondary";

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={spacingTokens.sm}
			px={spacingTokens.lg}
			pt={compactTop ? spacingTokens.xs : 2.4}
			pb={spacingTokens.sm}
		>
			{icon}
			<Typography variant="overline" color={muted ? "grey.300" : labelColor}>
				{title}
			</Typography>
		</Stack>
	);
};
